// Reputation tiers. Thresholds are intentionally slow to reach: points only
// come from other users' appreciation (votes, saves, started conversations),
// with daily caps — see backend/src/services/reputation.ts.
export type ReputationTier = {
  name: string;
  min: number;
  color: string;
  background: string;
  border: string;
};

const TIERS: ReputationTier[] = [
  { name: 'Local Legend', min: 500, color: '#92400e', background: '#fef3c7', border: '#f59e0b' },
  { name: 'Trusted Local', min: 200, color: '#1e40af', background: '#dbeafe', border: '#60a5fa' },
  { name: 'Contributor', min: 50, color: '#9a3412', background: '#ffedd5', border: '#fb923c' }
];

export const getReputationTier = (reputation?: number | null): ReputationTier | null => {
  const score = typeof reputation === 'number' ? reputation : 0;
  return TIERS.find((tier) => score >= tier.min) || null;
};
